import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { transitions } from '@/css/resources/variables.css';
import { outlineA11y } from '@/css/resources/placeholders.css';
import {
	fontStyle,
	fluidBorderRadius,
	fluidBorderWidth,
} from '@/css/resources/mixins.css';

import tick from '@/assets/images/tick.svg';

const getDynamicLabelStyles = (formStyles) =>
	cssObj(
		fontStyle(
			{
				...formStyles?.checkbox?.label?.typography,
				textAlign: formStyles?.checkbox?.label?.textAlignment,
				color: formStyles?.checkbox?.label?.color,
			},
			false
		),
		{
			/* checkboox styles */
			'&::before': cssObj(
				fluidBorderWidth(formStyles?.input?.border?.width),
				fluidBorderRadius(formStyles?.input?.border?.radius),
				{
					background: formStyles?.input?.backgroundColor,
					borderColor: formStyles?.input?.border?.color,
				}
			),
		}
	);

const getDynamicStyles = (formStyles) =>
	cssObj({
		'.supt-inputCheckbox__label': getDynamicLabelStyles(formStyles),

		'.supt-inputCheckbox__error': fontStyle({
			...formStyles?.error?.typography,
			textAlign: formStyles?.error?.textAlignment,
			color: formStyles?.error?.color,
		}),
	});

const getStyles = (formStyles) =>
	css(getDynamicStyles(formStyles), {
		position: 'relative',

		'.supt-inputCheckbox__label': {
			position: 'relative',
			display: 'inline-block',
			paddingLeft: 'calc(16px + 1em)',
			cursor: 'pointer',

			/* TODO: refactor to use standard text styles? */
			a: {
				textDecoration: 'underline',
			},

			'&::before, &::after': {
				content: '""',
				position: 'absolute',
				width: '16px',
				height: '16px',
				top: 'calc((1.5em - 16px) / 2 - 1px)',
				left: '0',
				zIndex: 1,
			},

			/* checkboox styles */
			'&::before': {
				borderStyle: 'solid',
				transition: `all ${transitions.fast} ease-out`,
			},

			/* checkboox styles when checked */
			'&::after': {
				opacity: '0',
				transition: `opacity ${transitions.fast} ease-out`,
				backgroundImage: `url(${tick.src})`,
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'contain',
			},
		},

		'.supt-inputCheckbox__input': {
			position: 'absolute',
			bottom: '0',
			opacity: '0 !important',
			padding: '0',
			outline: 'none',

			'html:not(.using-mouse) &:focus-within ~ .supt-inputCheckbox__label':
				outlineA11y,
		},

		/* state: focus */
		'.supt-inputCheckbox__input:focus + .supt-inputCheckbox__label, .supt-inputCheckbox__input:not([disabled]) + .supt-inputCheckbox__label:hover':
			getDynamicLabelStyles(formStyles?.states?.hover),

		/* state: checked */
		'.supt-inputCheckbox__input:checked + .supt-inputCheckbox__label': {
			'&::after': {
				opacity: '1',
			},
		},

		/* state: disabled */
		'.supt-inputCheckbox__input[disabled] + .supt-inputCheckbox__label': {
			cursor: 'not-allowed',
			opacity: '0.7',
		},

		'.supt-inputCheckbox__error': {
			textAlign: 'left',
			marginBottom:
				'0' /* this makes sure we don't overlap with the component below: the margin-bottom of checkboxes is smaller than inputs, therefore there's not enough space for the error message negative margin trick */,

			position: 'absolute',
			left: '0',

			display: 'block',
		},
	});

export { getStyles };
